<template>
  <svg
    id="contour_copia"
    data-name="contour copia"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <title>74_layers-LIGHT</title>
    <path
      fill="#679940"
      class="cls-1"
      d="M59.21,37.7,50.91,32l8.3-5.7a4,4,0,0,0,0-6.6L34.27,2.56a4,4,0,0,0-4.54,0L4.79,19.7a4,4,0,0,0,0,6.6l8.3,5.7-8.3,5.7a4,4,0,0,0,0,6.6L29.73,61.44a4,4,0,0,0,4.54,0L59.21,44.3A4,4,0,0,0,59.21,37.7ZM8,22.37,30.74,6.72a2.23,2.23,0,0,1,2.52,0L56,22.37a.76.76,0,0,1,0,1.26L33.26,39.28a2.23,2.23,0,0,1-2.52,0L8,23.63A.76.76,0,0,1,8,22.37ZM30.74,57.28,8,41.62a.76.76,0,0,1,0-1.24l8-5.53,11.47,7.89a7.83,7.83,0,0,0,3.94,1.36,3.51,3.51,0,0,0,1.18,0,7.83,7.83,0,0,0,3.94-1.36L48,34.85h0l8,5.53a.76.76,0,0,1,0,1.24L33.26,57.28A2.23,2.23,0,0,1,30.74,57.28Z"
    />
  </svg>
</template>

<script>
export default {
  name: "BoxIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/BoxIcon.vue